<template>
  <div class="register-container">
    <el-form :model="form" label-width="150px" ref="userForm">
      <el-form-item label="Username：" prop="username" :rules="[{ required: true, message: 'Username is required' }]">
        <el-input v-model="form.username" />
      </el-form-item>
      <el-form-item label="Realname：" prop="realName" :rules="[{ required: true, message: 'Real name is required' }]">
        <el-input v-model="form.realName" />
      </el-form-item>
      <el-form-item label="Password：" prop="password" :rules="[{ required: true, message: 'Password is required' }]">
        <el-input v-model="form.password" type="password" />
      </el-form-item>

      <el-form-item label="Phone：" prop="phone" :rules="[{ required: true, message: 'Phone number is required' }]">
        <el-input v-model="form.phone" />
      </el-form-item>
      <el-form-item label="E-mail：" prop="email" :rules="[{ required: true, message: 'Email is required' }]">
        <el-input v-model="form.email" />

      </el-form-item>

      <el-form-item label="Verification Code：" prop="code" :rules="[{ required: true, message: 'Verification code is required' }]">
        <div class="code-wrapper">
          <el-input v-model="form.code" style="width: 120px;" /> <!-- 注意：这里v-model应绑定form.code -->
          <el-button @click="sendCode" style="width: 100px;">Send Code</el-button>
        </div>
      </el-form-item>

      <el-form-item label="Affiliations：" prop="workUnit" :rules="[{ required: true, message: 'Work unit is required' }]">
        <el-input v-model="form.workUnit" />
      </el-form-item>

      <el-form-item label="Oral presentation：" prop="isReport" :rules="[{ required: true, message: 'Please choose.' }]">
        <el-radio-group v-model="form.isReport">
          <el-radio value="1">Yes</el-radio>
          <el-radio value="0">No</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.isReport === '1'" label="Report Title：" prop="reportTitle">
        <el-input v-model="form.reportTitle" />
      </el-form-item>

      <el-form-item>
        <el-button style="width: 100px;" type="primary" @click="handleRegister">Register</el-button>
      </el-form-item>
    </el-form>


  </div>
</template>

<script>
import {
  ref,
  reactive,
  getCurrentInstance
} from 'vue'

import { ElMessage } from 'element-plus'
import request from "@/utils/request";
import router from "@/router";

export default {
  setup() {


    const { proxy } = getCurrentInstance();

    const form = reactive({
      username: '',
      realName: '',
      password: '',
      phone: '',
      code: '',
      email: '',
      workUnit: '',
      userRole: 'user',
      isReport: '',
      reportTitle: ''
    });


    const handleRegister = () => {
      proxy.$refs.userForm.validate(async (valid) => {
        if (valid) {

          request.post('/api/save', form)
            .then(res => {
              console.log("Response:", res);
              // 检查返回的状态码，如果成功再跳转
              if (res.code === '200') {
                // 请求注册成功后跳转到登录
                router.push('/login');
                /*window.location.href = '/login';*/

              } else {
                // 如果返回的状态码不是200，显示错误信息
                alert(res.msg);
              }
            })
            .catch(error => {
              // 捕获请求中的错误
              console.error("Error:", error);
              alert('Registration failed, please try again!');
            });
        } else {
          ElMessage({
            showClose: true,
            message: "Please fill in all required information",
            type: "error",
          });
        }
      });

    };

    const sendCode = () => {
      // 添加手机号验证
      if (!form.email) {
        ElMessage.error('Please enter email');
        return;
      }

      // 使用 GET 请求发送验证码[6,7](@ref)
      request.get('/api/sendMail', {
        params: {  // 使用 params 对象传递参数[6,7,8](@ref)
          email: form.email
        }
      })
        .then(res => {
          console.log("Response:", res);
          if (res.code === '200') {
            ElMessage.success('Verification code sent');
          } else {
            ElMessage.error(res.msg || 'Failed to send verification code');
          }
        })
        .catch(error => {
          console.error("Error:", error);
          ElMessage.error('Request failed, please try again');
        });
    };

    return { form, handleRegister, sendCode };
  }
};
</script>


<style>
/* el-form-item宽度对齐 */
.el-form-item {
  width: 100%;
  max-width: 500px;
  margin-bottom: 20px;
}

/* 注册界面容器 */
.code-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.code-wrapper .el-input {
  flex: 1;
}

.code-wrapper .el-input {
  flex: 1;
}

.checkbox-register>div {
  display: flex;
  align-items: center;
  /* 垂直居中对齐 */
  margin-bottom: 10px;
  /* 每行之间的间隔 */
}

.register-container {
  display: flex;
  justify-content: center;
  /* 使整个容器居中 */
  align-items: center;
  /* 使整个容器垂直居中 */
  /*background-color: #f0f0f0; /* 设置背景颜色为浅灰色 */
  padding: 20px;
  /* 添加内边距 */
  border-radius: 8px;
  /* 添加圆角 */
}

/* 注册表单 */
.register-container form {
  display: flex;
  flex-direction: column;
  /* 垂直排列表单内的元素 */
  align-items: center;
  width: 50%;
  background-color: #fff;
  /* 表单背景颜色为白色 */
  padding: 20px;
  border-radius: 8px;
  /* 圆角 */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  /* 阴影效果 */
}

/* 输入框、标签和按钮的样式 */
.register-container form input,
.register-container form label,
.register-container form button {
  width: 100%;
  /* 使输入框、标签和按钮宽度适应表单宽度 */
  max-width: 100%;
  /* 确保输入框、标签和按钮不会超过表单宽度 */
}

/* 按钮的样式 */
.register-container form button {
  margin: 5px 0;
  /* 按钮的上下间隔 */
  padding: 10px 20px;
  /* 按钮的内边距 */
  background-color: #007bff;
  /* 按钮背景颜色 */
  color: white;
  /* 按钮文字颜色 */
  border: none;
  /* 去掉按钮边框 */
  border-radius: 4px;
  /* 圆角 */
  cursor: pointer;
  /* 鼠标样式 */
}


.register-container form button:hover {
  background-color: #0056b3;
  /* 按钮悬停背景颜色 */
}
</style>
